import * as moment from 'moment';

export function getStartOfDay(date) {
    return moment.utc(date).hour(0).minute(0).second(0).millisecond(0).toISOString();
}